import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import { key_id } from "../../../App";
import envConfig from "../../../envConfig";
import Common from "../Common";

const bulkImportUrlGeneration = async ({
  filename,
  importType,
  contentType,
}) => {
  const headers = { "x-api-key": Common.decrypt(key_id()) };
  const url = `${
    envConfig.REACT_APP_REST_ENDPOINT
  }/documents/requestPreSignedURL?filename=${filename}&importType=${importType}${
    contentType ? `&contentType=${contentType}` : ""
  }`;
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    null,
    false,
    headers
  );
};

export default {
  bulkImportUrlGeneration,
};
